// chartConfig.js - упрощенная версия без проверки
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  Tooltip,
  Legend,
  Title,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler
} from 'chart.js';

// Просто регистрируем все компоненты
// Повторная регистрация не вызовет ошибку
ChartJS.register(
  ArcElement,
  BarElement,
  Tooltip,
  Legend,
  Title,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler
);

export default ChartJS;